import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

const styles = require('./Footer-styles.css');

const footer = ({ className }) => (
  <footer className={classnames(styles.footer, className)}>
    <div className={styles.footercontent}>
      <div className={styles.gracenote}>
        <img className={styles.logo} src="assets/Data-credit_Gracenote.png" alt="STATS Logo" />
      </div>
      <div className={styles.logoContainer}>
        <img className={styles.logo} src="assets/Analytics-By-Qlik-Mark-Horizontal-noRule_white.png" alt="Qlik Logo" />
      </div>
    </div>
  </footer>
);

footer.propTypes = {
  className: PropTypes.string,
};
footer.defaultProps = {
  className: null,
};

export default footer;
